import gql from "graphql-tag";

// should be the same as paycheckFormFragment since this fragment is for
// fetching new paycheck for and render it in the PaycheckForm PaycheckNewType
// inherits from PaycheckType on the server in type definitions

export const paycheckNewLineFragments = gql`
  fragment paycheckNewLineFragments on PaycheckNewLine {
    id
    number
    description
    altinnDescription
    altinnFordel
    quantity
    rate
    sum
    car {
      id
      name
      registrationNumber
    }
    project {
      id
      code
      name
    }
    department {
      id
      code
      name
      unit {
        id
      }
    }
    carOverwrite
    projectOverwrite
    departmentOverwrite
    taxable
    employerTaxable
    includeInVacationMoneyBase
    taxDeduction
    taxDeductionVoluntary
    calculatePositive
    calculationType
    garnishment
    garnishmentSamordnet
    vacationMoneyEarnedInPreviousYear
    paycheckLineTemplate {
      id
    }
    altinnAdditional {
      carAndBoat {
        listPriceForCar
        carRegistrationNumber
      }
    }
  }
`;

export const paycheckNewFragments = gql`
  fragment paycheckNewFragments on PaycheckNew {
    id
    currencyCode

    logo {
      id
      signedBlobId
      url(size: LARGE)
    }

    employeeName
    employeeAddress
    employeeZip
    employeeCity
    employeeSocialSecurityNumber
    employeeTemporarySocialSecurityNumber
    taxTable
    taxPercentage
    taxExemption
    taxDeductionMethod
    taxExemptionAmountLimit
    employeeBban
    employeeIban
    employeeSwift
    number
    leaveAndLayoffs{
      id
      startDate
      endDate
      description
    }
    comment

    employerName
    employerAddress
    employerZip
    employerCity
    employerOrganizationNumber
    unit {
      id
      mobile
      email
    }
    companyMunicipality {
      id
      number
      name
      bban
      organizationNumber
      organizationName
      organizationForm
      comment
      webpage
      email
      telephone
      mobile
      telefax
      address1
      address2
      address3
      zip
      city
      countyName
      employerTaxZone {
        id
        rate
        code
      }
    }
    companyMunicipalityTaxRate

    period {
      id
      name
      bookkeepingPeriod
      startDate
      endDate
    }
    startDate
    endDate
    workRelationEndReason
    workRelationDurationType
    journalDate
    dueDate
    paidDate

    shiftType
    employmentType
    occupation {
      id
      name
      code
      validFrom
    }
    workRelation {
      id
      startDate
      subUnit {
        id
        name
      }
      employee {
        id
        creditDays
        vacationMoneyPercentage
      }
    }
    employmentPercentage
    internalComment
    vacationMoneyPercentage

    shouldSendToAltinn
    shouldSendToFakturabank
    advancedMode

    draftSavedAt
    draftSavedBy { id name }

    savedAt
    savedBy { id name }

    lockedAt
    lockedBy { id name }

    paidDateUpdatedAt
    paidDateUpdatedBy {
      id name
    }

    paycheckLines {
      ...paycheckNewLineFragments
    }
    prepayments {
      id
      amount
      paymentDate
    }
  }
  ${paycheckNewLineFragments}
`;
